const LOCAL_KEY = 'BC_searchHistory';
const EXPIRATION_MONTHS = 2;

function isBrowser() {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}

function getStorage() {
  if (!isBrowser()) return { flights: defaultSearchData(), hotels: defaultSearchData() };

  const raw = localStorage.getItem(LOCAL_KEY);
  let data;

  try {
    data = raw ? JSON.parse(raw) : {};
  } catch {
    data = {};
  }

  data.flights = cleanExpired(data.flights || defaultSearchData());
  data.hotels = cleanExpired(data.hotels || defaultSearchData());
  data.offers = cleanExpired(data.offers || defaultSearchData());

  return data;
}

function defaultSearchData() {
  return {
    lastSearch: null,
    searches: [],
  };
}

function saveStorage(data) {
  if (!isBrowser()) return;

  data.flights = cleanExpired(data.flights);
  data.hotels = cleanExpired(data.hotels);
  data.offers = cleanExpired(data.offers);

  localStorage.setItem(LOCAL_KEY, JSON.stringify(data));
}

function cleanExpired(section) {
  const now = new Date();
  const cleanedSearches = (section.searches || []).filter(s => {
    return s.expiresAt && new Date(s.expiresAt) > now;
  });

  const cleanedLast = section.lastSearch && section.lastSearch.expiresAt && new Date(section.lastSearch.expiresAt) > now
    ? section.lastSearch
    : null;

  return {
    lastSearch: cleanedLast,
    searches: cleanedSearches,
  };
}

function getExpiryDate(referenceDate) {
  const base = new Date(referenceDate);
  base.setMonth(base.getMonth() + EXPIRATION_MONTHS);
  const now = new Date();
  return base < now ? now.toISOString() : base.toISOString();
}

// --- Flights ---

export function saveFlightSearch(search) {
  if (!isBrowser()) return;

  const data = getStorage();

  const enriched = {
    ...search,
    createdAt: new Date().toISOString(),
    expiresAt: getExpiryDate(search.departureDate || new Date())
  };

  let updated = data.flights.searches.filter(
    s => JSON.stringify(s) !== JSON.stringify(enriched)
  );

  updated.unshift(enriched);
  data.flights.lastSearch = enriched;
  data.flights.searches = updated.slice(0, 8);

  saveStorage(data);
}

export function getLastFlightSearch() {
  const data = getStorage();
  return data.flights.lastSearch;
}

export function getRecentFlightSearches() {
  const data = getStorage();
  return data.flights.searches;
}

export function removeFlightSearch(search) {
  if (!isBrowser()) return;

  const data = getStorage();

  data.flights.searches = data.flights.searches.filter(
    s => s.createdAt !== search.createdAt
  );

  saveStorage(data);
}

// --- Hotels ---

export function saveHotelSearch(search) {
  if (!isBrowser()) return;

  const data = getStorage();

  const enriched = {
    ...search,
    createdAt: new Date().toISOString(),
    expiresAt: getExpiryDate(search.departure || new Date())
  };

  let updated = data.hotels.searches.filter(
    s => JSON.stringify(s) !== JSON.stringify(enriched)
  );

  updated.unshift(enriched);
  data.hotels.lastSearch = enriched;
  data.hotels.searches = updated.slice(0, 5);

  saveStorage(data);
}

export function getLastHotelSearch() {
  const data = getStorage();
  return data.hotels.lastSearch;
}

export function getRecentHotelSearches() {
  const data = getStorage();
  return data.hotels.searches;
}

export function clearSearches() {
  if (!isBrowser()) return;
  localStorage.removeItem(LOCAL_KEY);
}

// --- Offers ---
export function saveOffer(search) {
  if (!isBrowser()) return;

  const data = getStorage();

  const enriched = {
    ...search,
    createdAt: new Date().toISOString(),
    expiresAt: getExpiryDate(search.departureDate || new Date())
  };

  let updated = data.offers.searches.filter(
    s => JSON.stringify(s) !== JSON.stringify(enriched)
  );

  updated.unshift(enriched);
  data.offers.lastSearch = enriched;
  data.offers.searches = updated.slice(0, 5);

  saveStorage(data);
}

export function getLastOffer() {
  const data = getStorage();
  return data.offers.lastSearch;
}

export function getRecentOffers() {
  const data = getStorage();
  return data.offers.searches;
}

export function removeRecentItem(search, searchKey) {
  const data = getStorage();
  data[searchKey].searches = data[searchKey].searches.filter(
    s => s.createdAt !== search.createdAt
  );
  saveStorage(data);
  return data
}

// Put search on the first place
export function updateRecentItemTime(search, searchKey) {
  const data = getStorage();
  data[searchKey].searches = data[searchKey].searches.map((s) =>
    s.createdAt === search.createdAt
      ? { ...s, createdAt: new Date().toISOString() } // or any new timestamp
      : s
  ).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  saveStorage(data);
  return data
}

export function clearAll(searchKey) {
  const data = getStorage();
  data[searchKey].searches = []
  saveStorage(data);
  return data
}
